/**
 * new orleans, la
 */
export const NEW_ORLEANS_SERVICE_LOCATION_ID = 1;
export const NEW_ORLEANS_ITEM_NUMBER_REGEX = /^[A-Z]-\d{5}-\d{2}$/;
export const NEW_ORLEANS_ITEM_NUMBER_FORMAT = 'A-00000-00';
export const NEW_ORLEANS_ITEM_NUMBER_EXAMPLE = 'A-12345-12';

/**
 * baltimore, md
 */
export const BALTIMORE_SERVICE_LOCATION_ID = 2;
export const BALTIMORE_ITEM_NUMBER_REGEX = /^\d{4}$/;
export const BALTIMORE_ITEM_NUMBER_FORMAT = '0000';
export const BALTIMORE_ITEM_NUMBER_EXAMPLE = '1234';

/**
 * development
 */
export const DEVELOPMENT_SERVICE_LOCATION_ID = 3;

/**
 * st george, la
 */
export const ST_GEORGE_SERVICE_LOCATION_ID = 4;
export const ST_GEORGE_ITEM_NUMBER_REGEX = /^\d{2}-\d{6}$/;
export const ST_GEORGE_ITEM_NUMBER_FORMAT = '00-000000';
export const ST_GEORGE_ITEM_NUMBER_EXAMPLE = '12-123456';

/**
 * service location id to item number data map
 */
export const SERVICE_LOCATION_ID_ITEM_NUMBER_DATA_MAP: { [key: number]: { regex: RegExp; format: string; example: string } } = {
  [NEW_ORLEANS_SERVICE_LOCATION_ID]: {
    regex: NEW_ORLEANS_ITEM_NUMBER_REGEX,
    format: NEW_ORLEANS_ITEM_NUMBER_FORMAT,
    example: NEW_ORLEANS_ITEM_NUMBER_EXAMPLE,
  },
  [BALTIMORE_SERVICE_LOCATION_ID]: {
    regex: BALTIMORE_ITEM_NUMBER_REGEX,
    format: BALTIMORE_ITEM_NUMBER_FORMAT,
    example: BALTIMORE_ITEM_NUMBER_EXAMPLE,
  },
  [ST_GEORGE_SERVICE_LOCATION_ID]: {
    regex: ST_GEORGE_ITEM_NUMBER_REGEX,
    format: ST_GEORGE_ITEM_NUMBER_FORMAT,
    example: ST_GEORGE_ITEM_NUMBER_EXAMPLE,
  },
};
